module.exports = function load(src, async) {
  var s = document.createElement('script');
  s.src = src;
  if (typeof async === 'boolean') {
    s.async = async;
  }
  (document.head || document.body).appendChild(s);
  return s;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/dynload/index.js
// module id = 1086
// module chunks = 11